import { Component, OnInit } from "@angular/core";
import { StepperService } from "../../../services/stepper.service";
import { AccountService } from "../../../services/account.service";
import { Router } from "@angular/router";
import { IErrorAlert } from '../../../interfaces/error.interface';

@Component({
  selector: "app-create-account-success",
  templateUrl: "./create-account-success.component.html",
  styleUrls: ["../../auth.styles.css"],
})
export class CreateAccountSuccessComponent implements OnInit {

  constructor(
    public _stepper: StepperService,
    public _account: AccountService,
    private _router: Router
  ) {
    if (!this._account.account.company.ruc) {
      this._router.navigate(["/create-account/company"]);
    }
    this._stepper.hideStepper();
  }

  ngOnInit(): void {}

  generateToken() {
    this._account.generateToken({
      docNumber: this._account.getAdminData().docNumber,
      docType: this._account.getAdminData().docType,
      ruc: this._account.getCompanyData().ruc,
    }).subscribe()
    
    this._router.navigate(['/create-password'])
  }
}
